/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CustomMetricConfigurationListRequestSortCriteria {
    getFixupPrototypeFunction() { return CustomMetricConfigurationListRequestSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<CustomMetricConfigurationListRequestSortCriteria>): CustomMetricConfigurationListRequestSortCriteria {
        let obj = Object.assign(new CustomMetricConfigurationListRequestSortCriteria(), model);
        CustomMetricConfigurationListRequestSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CustomMetricConfigurationListRequestSortCriteria>): CustomMetricConfigurationListRequestSortCriteria {
        if (!model) return null;
        return CustomMetricConfigurationListRequestSortCriteria.newInstance(<CustomMetricConfigurationListRequestSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CustomMetricConfigurationListRequestSortCriteria) {
        if (!obj) return;

        models.CustomMetricConfigurationListRequestSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CustomMetricConfigurationListRequestSortCriteria): boolean {
        Object.setPrototypeOf(obj, CustomMetricConfigurationListRequestSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.CustomMetricConfigurationListRequestSortColumn;

    ascending: boolean;

}
